<div class="jumbotron jumbotron-fluid" style="background-image: url('assets/img/tablet.jpg');">
	<div class="bg-opacity"></div>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="text-center">
  					<span class="box-number">12</span>
  					<p>N° Serie: 024844536 </p>
				</div>
			</div>
			<ul class="nav nav-tabs nav-status-box">
			  <li class="nav-item">
			    <a class="nav-link active" data-toggle="tab" href="#status">Estado</a>
			  </li>
			  <li class="nav-item">
			    <a class="nav-link" data-toggle="tab" href="#views">Pantallas</a>
			  </li>
			  <li class="nav-item">
			    <a class="nav-link" data-toggle="tab" href="#history">Historial</a>
			  </li>
			</ul>
		</div>
	</div>
</div>

<!-- Dropup de acciones -->
<div class="btn-group dropup btn-dropup-actions">
    <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span>+</span>
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <a class="dropdown-item" (click)="openBox()" style="font-size: 25px;">Open Front Door</a>
      <a class="dropdown-item" (click)="closeBox()" style="font-size: 25px;">Close Front Door</a>
      <a class="dropdown-item" (click)="openBackDoorBox()" style="font-size: 25px;">Open Back Door</a>
      <a class="dropdown-item" (click)="forceStopBox()" style="font-size: 25px;">Force Stop</a>
    </div>
  </div>

<div class="tab-content">
	<!-- Status Tab -->
	<div class="tab-pane active" id="status">
		<p class="status-box">Current box status: <span *ngIf="loaded" class="badge badge-success badge-status">{{status.description}}</span> <span *ngIf="!loaded" class="badge badge-warning badge-status">Desconectado</span></p>
		<div class="container" *ngIf="loaded">
			<div class="row">
				<div class="col-12">
					<div class="item-status-wrapper">
						<div class="card card-status">
						  <div class="card-header bg-success">
						    Obstrucción
						  </div>
						  <div class="card-body">
						    <span class="badge badge-success">{{status['pins'][37].state == 1 ? 'Ok' : 'Obstruido'}}</span>
						  </div>
						</div>
						<div class="card card-status">
						  <div class="card-header bg-success">
						    Apertura
						  </div>
						  <div class="card-body">
						    <span class="badge badge-success">{{status['pins'][21].state == 1 ? 'Ok' : 'Funcionando'}}</span>
						  </div>
						</div>
						<div class="card card-status">
						  <div class="card-header bg-success">
						    Cierre
						  </div>
						  <div class="card-body">
						    <span class="badge badge-success">{{status['pins'][23].state == 1 ? 'Ok' : 'Funcionando'}}</span>
						  </div>
						</div>
						<div class="card card-status">
						  <div class="card-header bg-success">
						    Fin de Carrera Apertura
						  </div>
						  <div class="card-body">
						    <span class="badge badge-success">{{status['pins'][37].state == 1 ? 'OFF' : 'ON'}}</span>
						  </div>
						</div>
						<div class="card card-status">
						  <div class="card-header bg-success">
						    Fin de Carrera Cierre
						  </div>
						  <div class="card-body">
						    <span class="badge badge-success">{{status['pins'][11].state == 1 ? 'OFF' : 'ON'}}</span>
						  </div>
						</div>
						<div class="card card-status">
						  <div class="card-header bg-success">
						    Puerta trasera accionada
						  </div>
						  <div class="card-body">
						    <span class="badge badge-success">{{status['pins'][29].state == 1 ? 'Ok' : 'Funcionando'}}</span>
						  </div>
						</div>
						<div class="card card-status">
						  <div class="card-header bg-success">
						    Puerta trasera
						  </div>
						  <div class="card-body">
						    <span class="badge badge-success">{{status['pins'][37].state == 1 ? 'Cerrada' : 'Abierta'}}</span>
						  </div>
						</div>
						
					</div>				
				  	
			  	</div>
			</div>		
		</div>		
	</div>
	<div class="tab-pane fade" id="views">
		<div class="views-wrapper">
			<a (click)="gotoIdle()" class="view-item" style="background-image: url('assets/img/portadas/portada-idle.png');">
				<div class="bg-opacity"></div>
				<h1 class="vi-title">Pantalla <br> Idle</h1>
			</a>
			<a (click)="gotoBlack()" class="view-item" style="background-image: url('assets/img/portadas/portada-black.png');">
				<div class="bg-opacity"></div>
				<h1 class="vi-title">Pantalla <br> Black</h1>
			</a>
			<a (click)="gotoReady()" class="view-item" style="background-image: url('assets/img/portadas/portada-checkgreen.png');">
				<div class="bg-opacity"></div>
				<h1 class="vi-title">Pantalla <br> Pedido Listo</h1>
			</a>
			<a (click)="viewVideo()" class="view-item" style="background-image: url('assets/img/portadas/portada-checkgreen.png');">
				<div class="bg-opacity"></div>
				<h1 class="vi-title">Ver Video</h1>
			</a>
		</div>
	</div>
	<div class="tab-pane fade" id="history">...</div>
</div>